var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{staticClass:"card-custom",attrs:{"no-body":""}},[_c('b-card-body',[_c('Search',{on:{"onCheckIn":_vm.getAllCheckIn,"onCheckOut":_vm.getAllCheckIn}}),_c('MemberCheckIn',{attrs:{"serverParams":_vm.serverParams,"table":_vm.table},on:{"onSearch":_vm.getAllCheckIn}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }